import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import { CollapseTransition } from '@cloud-sn/v-utils';
import InnerNode from './innerNode';
export default {
  name: 'VirtualTreeNode',
  extends: InnerNode,
  computed: {
    showLine: function showLine() {
      return this.renderShowLine();
    },
    styles: function styles() {
      var level = this.node.level;
      return {
        paddingLeft: "".concat(level * 20, "px")
      };
    }
  },
  methods: {
    renderShowLine: function renderShowLine() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          isTreeShowLine = this.isTreeShowLine,
          allTreeNodes = this.allTreeNodes,
          _this$node = this.node,
          level = _this$node.level,
          parent = _this$node.parent,
          key = _this$node.key;

      if (!isTreeShowLine) {
        return null;
      }

      var isLastNodeInGroup = {};
      var parentNode = parent;
      var nodeKey = key;
      var nodeLevel = level;

      while (parentNode && parentNode.children) {
        var isLastChild = parentNode.children[parentNode.children.length - 1].key === nodeKey;
        isLastNodeInGroup[nodeLevel] = isLastChild;
        nodeKey = parentNode.key;
        nodeLevel = parentNode.level;
        parentNode = parentNode.parent;
      }

      if (nodeLevel === 0 && allTreeNodes) {
        isLastNodeInGroup[0] = allTreeNodes[allTreeNodes.length - 1].key === nodeKey;
      }

      var lines = [];

      for (var i = level; i >= 0; i -= 1) {
        var isLastNode = isLastNodeInGroup[i];

        if (!isLastNode) {
          lines.push(h("span", {
            "class": "".concat(prefixCls, "-indent-line"),
            "style": "left:".concat(i * 20 + 12, "px")
          }));
        }
      }

      return lines.length > 0 ? h("span", [lines]) : null;
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        styles = this.styles,
        isVisible = this.node.isVisible,
        showLine = this.showLine,
        innerSwitcher = this.innerSwitcher,
        innerCheckbox = this.innerCheckbox,
        innerSelector = this.innerSelector,
        onDragEnter = this.onDragEnter,
        onDragOver = this.onDragOver,
        onDragLeave = this.onDragLeave,
        onDrop = this.onDrop;
    var on = {
      dragenter: onDragEnter,
      dragleave: onDragLeave,
      dragover: onDragOver,
      drop: onDrop
    };
    return isVisible ? h(CollapseTransition, [h("li", _mergeJSXProps([{}, {
      class: classes,
      attrs: {
        tabindex: 0
      },
      style: styles,
      on: on
    }]), [[showLine, innerSwitcher, innerCheckbox, innerSelector]])]) : null;
  }
};